export enum ChartType {
  BTCDominance = 'BTC_Dominance',
  Total_Volume = 'Total_Volume',
  TVLPerProtocols = 'TVL_per_Protocols',
  USDStablecoinMarketCap = 'USD_Stablecoin_Marketcap',
  TVLPerBlockChain = 'TVL_per_Blockchain',
  Top5CMC = 'Top5_CMC ',
  Spot_ETF_BTC_AUM_USD = 'Spot_ETF_BTC_AUM_USD',
  Spot_ETF_ETH_AUM_USD = 'Spot_ETF_ETH_AUM_USD',
  Spot_ETF_ETH_Flows_USD = 'Spot_ETF_ETH_Flows_USD',
  Spot_ETF_BTC_Flows_USD = 'Spot_ETF_BTC_Flows_USD',
  Spot_ETF_BTC_Total_AUM_Native = 'Spot_ETF_BTC_Total_AUM_Native',
  Spot_ETF_BTC_AUM_Native = 'Spot_ETF_BTC_AUM_Native',
  Spot_ETF_ETH_AUM_Native = 'Spot_ETF_ETH_AUM_Native',
  Spot_ETF_ETH_MarketShare = 'Spot_ETF_ETH_MarketShare',
  Spot_ETF_BTC_Total_AUM_USD = 'Spot_ETF_BTC_Total_AUM_USD',
  Spot_ETF_BTC_MarketShare = 'Spot_ETF_BTC_MarketShare',
  Spot_ETF_ETH_Total_AUM_USD = 'Spot_ETF_ETH_Total_AUM_USD',
  Spot_ETF_ETH_Total_AUM_Native = 'Spot_ETF_ETH_Total_AUM_Native',
  RWA_Total_TVL = 'RWA_Total_TVL',
  RWA_Volume_Stablecoins_VS_Visa = 'RWA_Volume_Stablecoins_VS_Visa',
  RWA_Most_Popular_Networks = 'RWA_Most_Popular_Networks',
  RWA_Total_Stablecoins_TVL = 'RWA_Total_Stablecoins_TVL',
  RWA_Money_Market_Funds_NonTokenized_TVL_FitchRatings = 'RWA_Money_Market_Funds_NonTokenized_TVL_FitchRatings',
  RWA_Money_Market_Funds_TVL_Issuers = 'RWA_Money_Market_Funds_TVL_Issuers',
  RWA_Most_Popular_Networks_No_Stablecoins = 'RWA_Most_Popular_Networks_No_Stablecoins',
  RWA_Total_TVL_No_Stablecoins = 'RWA_Total_TVL_No_Stablecoins',
  RWA_Total_Stablecoins_Euro_TVL = 'RWA_Total_Stablecoins_Euro_TVL',
  RWA_Money_Market_Funds_TVL_Products = 'RWA_Money_Market_Funds_TVL_Products',
  RWA_Private_Credit_TVL_Network = 'RWA_Private_Credit_TVL_Network',
  RWA_Private_Credit_NonTokenized_TVL_IMF = 'RWA_Private_Credit_NonTokenized_TVL_IMF',
  RWA_Private_Credit_TVL_Protocols = 'RWA_Private_Credit_TVL_Protocols'
}